/* Handler for filter
!! Main function based on AlpineJS !!
========================================================================================== */


Alpine.data('mainProductFilter', () => ({
    init(){},

    // Reset all filters for type
    resetFilterType(type) {
        // Dispatch event to parent component
        Livewire.dispatch('resetFilterType', {type: type});
    },

    // Reset all filters single
    resetFilterSingle(type, key) {
        // Dispatch event to parent component
        Livewire.dispatch('resetFilterSingle', {type: type, key: key});
    },

    // Reset all filters
    resetFilterAll() {
        // Dispatch event to parent component
        Livewire.dispatch('resetFilterAll');
    },

    // Init noUiSlider
    initNoUiSlider(elementId, updateEventName) {


        const sliderElement = $(document).find('#' + elementId);
        let slider = sliderElement[0];
        let start = sliderElement.data('start');
        let end = sliderElement.data('end');
        // Get the range from data attribute, like an object
        let rawData = sliderElement.data('range');
        // Replace single quotes with double quotes for JSON parsing
        rawData = rawData.replace(/'/g, '"');
        let rangeData = '';
        rangeData = typeof rawData === 'string' ? JSON.parse('{'+rawData+'}') : rawData;

        console.log(start,end,rangeData);

        noUiSlider.create(slider, {
            start: [start, end],
            snap: true,
            connect: true,
            tooltips: [
                wNumb({decimals: 0}),
                wNumb({decimals: 0}),
            ],
            range: rangeData,
        });

        slider.noUiSlider.on('change', function (values, handle) {
            console.log(values[0], values[1]);
            // Dispatch update for interested variable
            Livewire.dispatch(updateEventName, {
                value: {
                    0: parseFloat(values[0]),
                    1: parseFloat(values[1])
                }
            });
        });

    }
}));

